import { topicsData } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-10">
          话题标签
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {topicsData.map((topic) => {
            const colors = colorMap[topic.color] || colorMap.primary;
            return (
              <span
                key={topic.id}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full ${colors.bg} ${colors.text} text-sm font-medium cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap`}
              >
                {topic.name}
                <span className="text-xs opacity-70">{topic.heat}</span>
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}